import { FeatureFlagService } from "./feature-flag/feature-flag.service";

const featureFlag = new FeatureFlagService();

export default featureFlag;
